import "@/App.css";
import { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FormContextProvider } from "@/components/context/useFormContext";
import { GeneralForm } from "@/components/forms/generalForm";
import { VEHICLE_ENQUIRY } from "@/lib/constants";

const queryClient = new QueryClient();

type AppProps = {
	rootElement: HTMLElement;
};

export default function App({ rootElement }: AppProps) {
	const [component, setComponent] = useState<string | undefined>(undefined);
	const [siteTitle, setSiteTitle] = useState<string | undefined>(undefined);
	const [form, setForm] = useState<string | undefined>(undefined);

	useEffect(() => {
		const container = rootElement?.dataset.component;
		const siteTitle = rootElement?.dataset.title;

		switch (container) {
			case "general":
				setForm(VEHICLE_ENQUIRY);
				break;
		}

		setSiteTitle(siteTitle);
		setComponent(container);
	}, [rootElement, siteTitle, form]);

	const renderComponent = () => {
		if (form === VEHICLE_ENQUIRY) {
			return <GeneralForm rootId={rootElement} siteTitle={siteTitle} />;
		}
	};

	return (
		<FormContextProvider id={rootElement}>
			<QueryClientProvider client={queryClient}>
				{siteTitle ? renderComponent() : <div>Loading...</div>}
			</QueryClientProvider>
		</FormContextProvider>
	);
}
